"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardMedia = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * CardMedia is used in storyblok redirect to react routes
 */
var CardMedia = function CardMedia(_ref) {
  var rootClass = _ref.rootClass,
      alt = _ref.alt,
      height = _ref.height,
      image = _ref.image,
      title = _ref.title,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass,
      style = _ref.style,
      classes = _ref.classes;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, _objectSpread(_objectSpread({}, style), {}, {
    height: height
  }));

  return /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    alt: alt,
    image: image,
    title: title,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid,
    classes: classes
  });
};

exports.CardMedia = CardMedia;
var _default = CardMedia;
exports.default = _default;
CardMedia.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * height is requred for media to display
   * value in px
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /** alt text for image */
  alt: _propTypes.default.string.isRequired,

  /** title text for image */
  title: _propTypes.default.string.isRequired,

  /**
   * url for image
   * Image to be displayed as a background image
   * */
  image: _propTypes.default.string.isRequired,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string,
  classes: _propTypes.default.shape()
};
CardMedia.defaultProps = {
  rootClass: [],
  height: '140px',
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: '',
  classes: {}
};